// extracted by mini-css-extract-plugin
export var container = "_99-1";
export var cornerButtonContainer = "_99-5";
export var disabled = "_99-2";
export var fileContainer = "_99-4";
export var hiddenInput = "_99-3";
export var widthContainer = "_99-0";